import React from "react";
import './Footer.css';
import { Grid, Container } from '@material-ui/core';
import { NavLink_Data_Footer } from "../../../Constants/Data_Json";
import NavLink from "../../../Helpers/NavLink/NavLink";

const Footer = () => {



    return (
        <>
            <footer className="footer">
                <Container>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={5} md={5}>
                            <h6>About Us</h6>
                            <p className="footer-para">
                                iesh Ayurveda looking forward to achieve those life goals to each and every person who belives us. We Believes the <b>"The Beauty Of Health"</b> of a person in the internal and external well being...
                            </p>
                            <div className="footerLogo">
                                <img src="/Img/MainLogo.svg" alt="MainLogo" />
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={4} md={4}>
                            <h6>Quick Links</h6>
                            <div className='NavLink'>
                                {NavLink_Data_Footer.map((link, i) => (
                                    <NavLink key={i} to={link.path}>
                                        {link.label}
                                    </NavLink>
                                ))}
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={3} md={3}>
                            <h6>Connect with us</h6>
                            <div className="contactImg">
                                <a style={{ display: "table-cell" }} href="https://www.facebook.com/iesh.ayurvedha" target="_blank" >
                                    <img src="/Img/Facebook.svg" alt="Facebook" />
                                </a>
                                <a href="https://www.instagram.com/ieshayurveda?r=nametag" style={{ display: "table-cell" }} target="_blank" >
                                    <img src="/Img/LinkedIn.svg" alt="LinkedIn" />
                                </a>
                                <a >
                                    <img src="/Img/Twitter.svg" alt="Twitter" />
                                </a>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </footer>
            <div className="copyRight">
                &copy; 2021 iESHAYURVEDA
            </div>
        </>
    )
}

export default Footer;